import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExpenseMoneyIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.3369 14.6347C13.3513 14.6347 14.1736 13.8123 14.1736 12.7979C14.1736 11.7835 13.3513 10.9612 12.3369 10.9612C11.3225 10.9612 10.5001 11.7835 10.5001 12.7979C10.5001 13.8123 11.3225 14.6347 12.3369 14.6347Z",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.5969 7.29785H5.4032C4.05067 7.29785 2.95422 8.3943 2.95422 9.74683V15.8489C2.95422 17.2014 4.05067 18.2979 5.4032 18.2979H19.5969C20.9495 18.2979 22.0459 17.2014 22.0459 15.8489V9.74683C22.0459 8.3943 20.9495 7.29785 19.5969 7.29785Z",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.7102 10.9716C20.9454 10.842 20.2398 10.4777 19.6913 9.92921C19.1429 9.38071 18.7785 8.67518 18.6489 7.9104",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.6489 17.593C18.7785 16.8282 19.1429 16.1227 19.6913 15.5742C20.2398 15.0257 20.9454 14.6614 21.7102 14.5317",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.37769 14.5317C4.14247 14.6614 4.84799 15.0257 5.39649 15.5742C5.94499 16.1227 6.30929 16.8282 6.43891 17.593",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.43891 7.9104C6.30929 8.67518 5.94499 9.38071 5.39649 9.92921C4.84799 10.4777 4.14247 10.842 3.37769 10.9716",
			stroke: "black",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgExpenseMoneyIcon;
